// extracted by mini-css-extract-plugin
export default {"container":"InfiniteComments_container__e-15a","commentsContainer":"InfiniteComments_commentsContainer__cel4p"};